import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { RotacionPesajeVeterinariaService } from "../../../../generated/grpc/pesaje_ganaderia_pb";
import { grpcRotacionPesajeVeterinariaDatabase } from "../database/GrpcRotacionPesajeVeterinariaDatabase";
import { RotacionPesajeVeterinariaResponse } from "../response/RotacionPesajeVeterinariaResponse";
import { fx_aplicarCambiosMovimientoAsync } from "./aplicarCambiosMovimiento";

/** Variante gRPC-Web de `RotacionPesajeVeterinariaDeleteService` (ver ese
 *  archivo). `deleteOneAsync` lo saca de su base local y
 *  `fx_aplicarCambiosMovimientoAsync` escribe los lotes y las compras que el
 *  server recalculó, que vienen en la respuesta (2026-10-08). */
export class RotacionPesajeVeterinariaDeleteGrpcService
  implements IDeleteService<RotacionPesajeVeterinariaResponse>
{
  async deleteAsync(item: RotacionPesajeVeterinariaResponse): Promise<void> {
    const client = createClient(RotacionPesajeVeterinariaService, grpcTransportProvider.get());

    let respuesta;
    try {
      respuesta = await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcRotacionPesajeVeterinariaDatabase.deleteOneAsync(item.id);
    await fx_aplicarCambiosMovimientoAsync(respuesta);
  }
}
